import { sizeLabel } from './format.js';

/**
 * The PSD starter-template downloads a commission's brief should offer, built from
 * the public /api/config. A tile-brush commission gets both art-style templates; a
 * miniature gets the one template for its size, since the flatten requires the
 * exact canvas that size's template carries. Anything else has no template.
 *
 * Returns [] until the config has loaded, and omits any template the config
 * doesn't list.
 * @param {{ asset_type?: string, miniature_size?: string }|null|undefined} commission
 * @param {{ tileBrushTemplateContinuousUrl?: string, tileBrushTemplateSegmentedUrl?: string, miniatureTemplateUrls?: Record<string, string> }|null|undefined} config
 * @returns {{ label: string, url: string }[]}
 */
export function commissionTemplateLinks(commission, config) {
    if (!commission || !config) return [];

    if (commission.asset_type === 'mapmaking-tile-brush') {
        return [
            {
                label: 'Tile-Brush Template — Continuous (PSD)',
                url: config.tileBrushTemplateContinuousUrl,
            },
            {
                label: 'Tile-Brush Template — Segmented (PSD)',
                url: config.tileBrushTemplateSegmentedUrl,
            },
        ].filter((link) => link.url);
    }

    if (commission.asset_type === 'miniature' && commission.miniature_size) {
        const url = config.miniatureTemplateUrls?.[commission.miniature_size];
        if (!url) return [];
        return [
            {
                label: `Miniature Template — ${sizeLabel('miniature', commission.miniature_size)} (PSD)`,
                url,
            },
        ];
    }

    return [];
}
